const ENC_PREFIX = "chatenc";
const ENC_VERSION = "v1";

const textEncoder = new TextEncoder();
const textDecoder = new TextDecoder();

function b64ToBytes(b64) {
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes;
}

function bytesToB64(bytes) {
  let bin = "";
  for (let i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
  return btoa(bin);
}

export function isEncryptedChatPayload(value) {
  return typeof value === "string" && value.startsWith(`${ENC_PREFIX}:${ENC_VERSION}:`);
}

async function importAesKeyRaw(keyBytes) {
  return window.crypto.subtle.importKey("raw", keyBytes, "AES-GCM", false, ["encrypt", "decrypt"]);
}

export async function encryptChatText({ keyBase64, plaintext }) {
  const keyBytes = b64ToBytes(String(keyBase64 || ""));
  if (keyBytes.length !== 32) throw new Error("Invalid chat key");
  const key = await importAesKeyRaw(keyBytes);

  const iv = window.crypto.getRandomValues(new Uint8Array(12));
  const data = textEncoder.encode(String(plaintext ?? ""));
  const out = new Uint8Array(await window.crypto.subtle.encrypt({ name: "AES-GCM", iv }, key, data));

  // WebCrypto returns ciphertext || tag (16 bytes)
  const tag = out.slice(out.length - 16);
  const ciphertext = out.slice(0, out.length - 16);

  return `${ENC_PREFIX}:${ENC_VERSION}:${bytesToB64(iv)}:${bytesToB64(tag)}:${bytesToB64(ciphertext)}`;
}

export async function decryptChatText({ keyBase64, encoded }) {
  if (!isEncryptedChatPayload(encoded)) return String(encoded ?? "");

  const parts = String(encoded).split(":");
  // chatenc:v1:iv:tag:ciphertext
  if (parts.length !== 5) throw new Error("Invalid encrypted payload");

  const keyBytes = b64ToBytes(String(keyBase64 || ""));
  if (keyBytes.length !== 32) throw new Error("Invalid chat key");
  const key = await importAesKeyRaw(keyBytes);

  const iv = b64ToBytes(parts[2]);
  const tag = b64ToBytes(parts[3]);
  const ciphertext = b64ToBytes(parts[4]);
  const combined = new Uint8Array(ciphertext.length + tag.length);
  combined.set(ciphertext, 0);
  combined.set(tag, ciphertext.length);

  const plainBuf = await window.crypto.subtle.decrypt({ name: "AES-GCM", iv }, key, combined);
  return textDecoder.decode(plainBuf);
}

